import React, { useEffect } from 'react'
import { useState } from 'react'
import { BackButton } from '@/components/layout/NavBar'
import { Services } from '@/services/services'

import { CurrentSession } from '@/services/repository/session'
import { MainPageLayout } from '@/components/layout/MainLayout'
import { Translates } from '@/services/repository/i18n'

import { supportPageContacts } from '@/env/contact'
import { ContactPageBody } from '@/components/contact/PageBody'

export const SupportPage = ({ services, session }: { services: Services, session?: CurrentSession }) => {
  const [translates, setTranslates] = useState<Translates>()

  useEffect(() => {
    if (session) {
      setTranslates(session.translates)
      return
    }
    services.i18n.get('main').then(setTranslates)
  }, [session])

  if (translates === undefined) {
    return <div className='spinner'></div>
  }

  return <MainPageLayout pageName='contact' services={services} translates={translates}
    navbarLeft={<BackButton services={services} translates={translates} />}>
    <ContactPageBody title='page.contact.title' contacts={supportPageContacts} translates={translates} />
  </MainPageLayout>
}
